import styled from "styled-components";

export const NavBarContainer = styled.div`
  height: 77px;
  /* min-height: 100px; */
  /* max-width: 1000px; */
  /* background:${(props) => props.bg}; */
  /* background-color: #f5f8ff; */
  background-color: #ffffff;

  padding: 0rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  /* margin-bottom: 2rem; */
  border-bottom: 1px solid #eaeaea;
  #mySidenav {
    display: none;
  }
  #fakeNav {
    display: none;
  }
  @media (max-width: 1210px) {
    & {
      #mySidenav {
        display: block;
      }
      #fakeNav {
        display: block;
        height: 100%;
        width: 0;
        position: fixed;
        top: 0;
        z-index: 999;
        left: 250px;
        background: none;
        overflow-x: hidden;
      }
      .sidenav {
        /* height: 100%; */
        width: 0;
        position: fixed;
        z-index: 999;
        /* top: 60px; */
        top: 0px;
        left: 0;
        background-color: white;
        overflow-x: hidden;
        transition: 0.5s;
        padding-top: 20px;
      }
      .NavLink {
        /* width: 50%; */
        width: 80%;
        margin: 0 auto;
        /* margin-bottom: 40px; */
        border-bottom: 1px solid #eaeaea;
        padding-bottom: 1.5rem;
        padding-top: 1.5rem;
        cursor: pointer;
        span {
          color: #000000;
          font-size: 16px;
          font-weight: bold;
        }
      }
      .routerlink {
        text-decoration: none;
      }

      .NavLink:hover {
        border-bottom: 1px solid white;
      }
      #Personal {
        display: flex;
        align-items: center;
        position: relative;
      }
      .iconDown {
        margin-left: 0.26rem;
        margin-top: 0.26rem;
      }
    }
  }
  @media (max-width: 700px) {
    padding: 0rem 1rem;
  }
`;
export const Logo = styled.div`
  img {
    /* width: 70%; */
  }
  @media (max-width: 700px) {
    img {
      width: 120px;
    }
  }
`;

export const NavLinks = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 140px;

  /* margin-right: 7rem; */
  margin: 0 auto;
  .NavLink {
    cursor: pointer;
    margin: -4.5rem;
    span {
      color: #000000;
      font-size: 16px;
      font-weight: 700;
    }
  }
  #Personal {
    display: flex;
    align-items: center;
    position: relative;
  }
  .iconDown {
    margin-left: 0.26rem;
    margin-top: 0.26rem;
  }
  .routerlink {
    text-decoration: none;
  }

  .NavLink:hover {
    border-bottom: 2px solid white;
  }
  @media (max-width: 1210px) {
    & {
      display: none;
    }
  }
`;
export const Register = styled.div`
  display: flex;
  align-items: center;
  #SignIn {
    color: #000000;
    height: 70%;
    /* padding: 0.6rem 2.4rem; */
    padding: 0.7rem 2rem;

    border: 2px solid black;
    border-radius: 15px;
    margin-left: 0.5rem;
    background: none;
  }
  #SignIn:hover {
    /* background: rgb(0, 0, 0, 0.2); */

    /* color: white !important;
    transition: all 0.4s ease-out; */
  }

  @media (max-width: 1210px) {
    & {
      display: none;
    }
  }
`;

export const Button = styled.button`
  /* border-radius: 40px; */

  padding: 20px 40px;
  span {
    font-weight: bold;
    color: #000000;
    font-size: 16px;
  }
  /* background-color: rgb(255, 255, 255, 0.2); */

  border: 1px solid black;
  cursor: pointer;
`;

export const MenuOpen = styled.div`
  display: none;
  z-index: 1000;
  @media (max-width: 1210px) {
    & {
      display: block;
      top: -4px;
      right: 0;

      img {
        cursor: pointer;
      }
    }
  }
`;
export const Menu = styled.div`
  display: none;
  z-index: 1000;
  @media (max-width: 1210px) {
    & {
      display: block;
      position: fixed;
      top: 0px;
      right: 0;
      margin: 20px;
      img {
        cursor: pointer;
      }
    }
  }
`;
export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  z-index: 10;
`;

export const DropdownItem = styled.div`
  /* padding: 10px 2rem; */
  padding: 0.56rem 0.56rem;
  border-bottom: 1px solid #f7f7f7;
  a {
    text-decoration: none;
    color: black;
    display: block;
    width: 100%;
  }

  &:last-child {
    border-bottom: none;
    width: max-content;
  }
`;
